import { ReactNode } from 'react';
import { useDraggable } from '@dnd-kit/core';
import { ListItemButton } from '@rossum/ui/material';
import { getSidebarListItemStyles } from '../../sidebar/styles';

type QueueProps = {
  onClick: () => void;
  queueId: number;
  currentQueueId?: number;
  workspaceUrl: string;
  children: ReactNode;
  queueName: string;
  draggable: boolean;
};

export const DraggableQueue = ({
  onClick,
  queueId,
  queueName,
  currentQueueId,
  workspaceUrl,
  children,
  draggable,
}: QueueProps) => {
  const draggableId = `draggable-queue-${queueId}`;
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: draggableId,
    data: { id: queueId, name: queueName, workspaceUrl },
    disabled: !draggable,
  });

  // dnd-kit's attributes describe the element as a drag handle: when dragging
  // is disabled they mark it aria-disabled and still describe it as
  // "draggable". The queue stays a clickable button either way, and
  // ListItemButton already provides role and tabIndex, so only spread them
  // while the queue can actually be dragged.
  const draggableAttributes = draggable ? attributes : undefined;

  const active = currentQueueId === queueId || isDragging;

  return (
    <ListItemButton
      ref={setNodeRef}
      data-cy="sidebar-queue"
      data-id={queueId}
      onClick={onClick}
      {...listeners}
      {...draggableAttributes}
      sx={{
        py: 1,
        color: active ? 'text.primary' : 'text.secondary',
        ...getSidebarListItemStyles(active),
        height: 1,
      }}
    >
      {children}
    </ListItemButton>
  );
};
